import { MessagingClient } from "../messagingClient";
import { BgCommands, BgCommandTypes } from "@whatslly/commons/bgCommands";

export const backgroundClient = new MessagingClient<BgCommandTypes>(BgCommands);
